const sampleSC = {};
export default sampleSC;
